
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { AddRole, UpdateRole } from '@routes/usersteams/models/role-model';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';
import { IRoleDetails, IRoles, IRolesForDropdown } from '@shared/services/api/legacy/roles-service/role-model';

@Injectable()
export class RolesService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${RolesService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/roles';

    public getRole(id: string): Observable<SuccessResponse<IRoleDetails> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IRoleDetails>>(RolesService.URL + '/' + id).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getRoles(): Observable<SuccessResponse<IRoles> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IRoles>>(RolesService.URL).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getRolesForDropdown(): Observable<SuccessResponse<IRolesForDropdown> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<IRolesForDropdown>>(RolesService.URL + '/dropdown').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public addRole(role: AddRole): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(RolesService.URL, role).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public updateRole(role: UpdateRole): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(RolesService.URL + '/' + role.id, role).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public deleteRole(id: string): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .delete<SuccessResponse<boolean>>(RolesService.URL + '/' + id).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
